import React, { useState } from "react";
import { Button, Form, Input, message, Upload } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import axios from "axios";
import { SERVER_ADDRESS } from "../../../Config/Config";

const AddCategory = () => {
  const [form] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [imageBase64, setImageBase64] = useState(null);

  // Convert file to base64
  const getBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

  const handleImageChange = async ({ fileList: newFileList }) => {
    setFileList(newFileList);
    if (newFileList.length > 0 && newFileList[0].originFileObj) {
      const base64 = await getBase64(newFileList[0].originFileObj);
      setImageBase64(base64);
    } else {
      setImageBase64(null);
    }
  };

  const onPreview = async (file) => {
    let src = file.url;
    if (!src) {
      src = await new Promise((resolve) => {
        const reader = new FileReader();
        reader.readAsDataURL(file.originFileObj);
        reader.onload = () => resolve(reader.result);
      });
    }
    const image = new Image();
    image.src = src;
    const imgWindow = window.open(src);
    imgWindow?.document.write(image.outerHTML);
  };

  const onFinish = async (values) => {
    try {
      const payload = {
        ...values,
        category_image: imageBase64, // send base64 string
      };

      const response = await axios.post(
        `${SERVER_ADDRESS}/api/add-cateogry`,
        payload
      );

      if (response.status === 200) {
        form.resetFields();
        setFileList([]);
        setImageBase64(null);
        message.success({
          content: "Category added Successfully",
          duration: 2,
        });
      } else {
        message.error({ content: "Category not added", duration: 2 });
      }
    } catch (error) {
      console.log(error);
      message.error({ content: "Internal server Error", duration: 2 });
    }
  };

  return (
    <div style={{ marginTop: "5rem" }}>
      <div style={{ fontSize: "2rem" }}>Fill Details</div>
      <Form
        form={form}
        style={{
          backgroundColor: "white",
          width: "60rem",
          marginTop: "2rem",
          padding: "2rem",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
          borderRadius: "0.6rem",
        }}
        onFinish={onFinish}
      >
        <Form.Item
          label="Category Name"
          name="category_name"
          rules={[
            { required: true, message: "Enter the category name" },
            {
              validator: (_, value) => {
                if (value && value.trim().toLowerCase() === "image") {
                  return Promise.reject("Category name cannot be 'image'");
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <Input placeholder="Enter Category name" />
        </Form.Item>

        <Form.Item
          label="Search Key"
          name="category_search_key"
          rules={[{ required: true, message: "Enter the category search key" }]}
        >
          <Input placeholder="Enter search key" />
        </Form.Item>

        <Form.Item
          label="Category Cover Image"
          name="category_image"
          valuePropName="fileList"
          getValueFromEvent={(e) => e && e.fileList}
          rules={[
            {
              validator: async () => {
                if (!imageBase64) {
                  return Promise.reject("Kindly Upload Category Image");
                }
              },
            },
          ]}
        >
          <Upload
            listType="picture-card"
            fileList={fileList}
            onChange={handleImageChange}
            onPreview={onPreview}
            showUploadList={{ showPreviewIcon: false }}
            beforeUpload={() => false} // prevent auto-upload
          >
            {fileList.length >= 1 ? null : (
              <div>
                <PlusOutlined />
                <div style={{ marginTop: 8 }}>Upload</div>
              </div>
            )}
          </Upload>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: 10, span: 16 }}>
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddCategory;
